import React from 'react';
import Icon from './Icon';
import Button from './Button';

const Modal = ({
  isOpen,
  show,
  onClose,
  title,
  children,
  width = 480,
  noClose = false,
  closeOnBackdrop = true,
  className = '',
}) => {
  const isVisible = isOpen || show;
  const handleBackdropClick = (e) => {
    if (closeOnBackdrop && e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleEscapeKey = React.useCallback((e) => {
    if (e.key === 'Escape' && !noClose) {
      onClose();
    }
  }, [noClose, onClose]);

  React.useEffect(() => {
    if (isVisible) {
      document.addEventListener('keydown', handleEscapeKey);
    }
    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isVisible, handleEscapeKey]);

  if (!isVisible) return null;

  return (
    <div className="modal-overlay" onClick={handleBackdropClick}>
      <div 
        className={`modal-content ${className}`}
        style={{ maxWidth: width }}
      >
        <div className="flex items-center justify-between mb-5">
          <h3 className="outfit font-bold text-lg" style={{ color: 'var(--text)' }}>
            {title}
          </h3>
          {!noClose && (
            <Button
              variant="secondary"
              size="sm"
              onClick={onClose}
              className="p-2"
            >
              <Icon name="x" size={16} />
            </Button>
          )}
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
